import React from 'react';
import { Icon } from '@/components';
import { AccountStore } from '@/stores';
import type { AuthorizedModuleType } from '@/layout';
import type { MenuDataItem } from '@/const/route.config';

import './index.less';

interface AuthContainerProps {
  children: React.ReactNode;
  matchMenu: MenuDataItem[];
  currentMenu?: MenuDataItem;
  authModule?: AuthorizedModuleType[];
  teamSelfInfo?: Record<string, any>;
  isExperienceMember?: boolean;
}

const AuthContainer: React.FC<AuthContainerProps> = ({
  children,
  authModule,
  matchMenu,
  currentMenu,
  teamSelfInfo,
  isExperienceMember,
}) => {
  if (isExperienceMember) {
    return children;
  }

  const firstMenuItem = matchMenu[0];
  const { moduleId } = JSON.parse(decodeURIComponent(firstMenuItem?.props || '{}'));
  const { teamInfoAuthKey, noAuthMsg } = JSON.parse(decodeURIComponent(currentMenu?.props || '{}'));
  const hasModuleAuth = authModule?.some((item) => item.moduleId === moduleId && item.status === 1);

  if (
    (moduleId && hasModuleAuth === false) ||
    (teamInfoAuthKey && (!teamSelfInfo || teamSelfInfo[teamInfoAuthKey] === 0))
  ) {
    return (
      <div className="fle-no-module-auth-container">
        <Icon type="icon-jiaosequanxian" />
        <span className="lock-text">{noAuthMsg || '您没有权限访问此模块，请联系管理员开通！'}</span>
      </div>
    );
  }

  return children;
};
export default AuthContainer;
